<template>
    <div class="vue-up-or-downgrade-vehicle-card">
        <div class="vehicle-teaser teaser form-type-checkbox" :class="{'checked': upgradeChecked}" @click="handleUpgrade">
            <span class="checkbox" :class="{'checked': upgradeChecked}"></span>

            <div class="title">
                <h4 class="virtual-h3 color-text mb-0 d-inline">{{ vehicle.title }}</h4>
                <p class="subtitle mb-0">{{ vehicle.subtitle }}</p>
            </div>

            <div class="image-price-wrapper">
                <div class="image">
                    <img v-if="hasImage" :src="vehicle.images" :alt="vehicle.title">
                </div>

                <div class="price font-weight-bold" v-if="vehicle.price_per_day">
                    {{ vehicle.price_per_day | vatExcluder | currencyFormatter }}
                    <small>per dag</small>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import translations from "../../mixins/translations";
import CurrencyFormatter from "../../mixins/CurrencyFormatter";

export default {
    name: "UpOrDowngradeVehicleCard",

    mixins: [translations, CurrencyFormatter],

    props: ['vehicle', 'gradeType', 'activeVehicle'],

    computed: {
        ...mapGetters([
            'getActiveVehicle',
            'getActiveLocation',
        ]),

        hasImage() {
            return !lodash.isEmpty(this.vehicle.images);
        },

        upgradeChecked() {
            return this.activeVehicle?.id === this.vehicle.id;
        }
    },

    methods: {
        handleUpgrade() {
            this.$emit('card-clicked', this.vehicle.id);
        }
    }
}
</script>
